const userKey = "user1"; 
const userKeyChoice = "userChoice1"; 

export function getChoiceUser() {
    const tempuser = localStorage.getItem(userKeyChoice);
    let user = tempuser != null && tempuser != "" ? JSON.parse(tempuser) : {};
    return user;
}
export function saveChoiceUser(data) {
    localStorage.setItem(userKeyChoice, JSON.stringify(data));
}



export function getUser() {
    const tempuser = localStorage.getItem(userKey);
    let user = tempuser != null && tempuser != "" ? JSON.parse(tempuser) : [];
    return user;
}

export function saveUser(data) {
    localStorage.setItem(userKey, JSON.stringify(data));
}

export function addSaveUser(user) {
    let tempuser = localStorage.getItem(userKey);
    //console.log('1', tempuser);
    //console.log('2', tempuser != null && tempuser != "" ? "**" : "*");
    let olduser = tempuser != null && tempuser != "" ? JSON.parse(tempuser) : [];
    console.log('olduser', olduser);
    let newuser = olduser == null ? [...user] : [...olduser, ...user];
    console.log('newuser', newuser);
    saveUser(newuser);
    //console.log(localStorage.getItem('user'));
}

export function deleteUser(id) {
    let tempuser = localStorage.getItem(userKey);

    let olduser = tempuser != null && tempuser != "" ? JSON.parse(tempuser) : [];
    if (olduser == [])
        return;

    console.log('olduser', olduser);
    let article = olduser.find(m => m.id === id);
    olduser.splice(olduser.indexOf(article), 1);

    console.log('article', article);
    console.log('olduser', olduser);
    saveUser(olduser);
    return article;
}

export function emptyUser() {
    localStorage.removeItem(userKey);
}
 